import { ChildModel, ModelBase } from 'store/model-base';
import { Promotion } from '../../promotions/models';

export class LinePromotions extends ModelBase {
    public static storeName: string = 'linePromotions';
    public static idAttribute: string = 'lineKey';

    public promos: Promotion[];
    public lineKey: string;

    public hasExtendedPromo: boolean;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.promos = data.promos || [];
        const toReturn: LinePromotions = super.create<LinePromotions>(data);

        if (toReturn.promos.length) {
            toReturn.hasExtendedPromo = toReturn.promos.some((promo: Promotion) => promo.isExtendedPromo || promo.isExtendedPromoPCT || promo.isExtendedPromoDollar);
        }

        /* eslint-disable @typescript-eslint/no-explicit-any */
        return <T> <any> toReturn;
        /* eslint-enable @typescript-eslint/no-explicit-any */
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'promos',
            model: Promotion
        }];
    }
}
